import { configNoHeaders, configWithTokenId, configNoHeadersV2 } from '@api/constructor-api'

const registerUserHandler = async(payload) => {
    return await configNoHeadersV2(async(API) => {
        return await API.post('auth/signup', payload)
    })
}

const checkPhoneHandler = async(payload) => {
    return await configNoHeaders(async(API) => {
        if(payload.restaurantAlias)
            return await API.get(`restaurant/${payload.restaurantAlias}/customer/${payload.PhoneNumberRef1}`)
        throw 'Not Empty Data'
    })
}

const checkLineHandler = async(payload) => {
    return configNoHeaders(async(API) => {
        return API.post('check-line', payload)
    })
}

const registerLineHandler = async(payload) => {
    return configWithTokenId(async(API) => {
        return API.patch('auth/open-line', payload)
    })
}

const closeLineHandler = async(payload) => {
    return configWithTokenId(async(API) => {
        return API.delete('auth/close-line', { data: payload })
    })
}

const verifyCodeCRMHandler = async(payload) => {
    return configNoHeadersV2(async(API) => {
        return API.post('auth/validate/phone', payload)
    })
}

const sentVerifyPhoneCRMHandler = async(payload) => {
    return configNoHeadersV2(async(API) => {
        return API.post('auth/send-verify-code', payload)
    })
}
const validateLineHandler = async(payload) => {
    return configNoHeadersV2(async(API) => {
        return API.post('auth/validate/line', payload)
    })
}

const checkLoginHandler = () => {
    return configWithTokenId((API) => {
        return API.get('auth')
    })
}

const getRecaptchaSitekey = () => {
    return process.env.VUE_APP_RECAPTCHA_SITE_KEY
}

export default {
    registerUserHandler,
    checkPhoneHandler,
    registerLineHandler,
    closeLineHandler,
    checkLineHandler,
    verifyCodeCRMHandler,
    sentVerifyPhoneCRMHandler,
    validateLineHandler,
    checkLoginHandler,
    getRecaptchaSitekey,
 }